import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Reseller({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Reseller.Outline {...props} />
  ) : (
    <Reseller.Solid {...props} />
  );
}

Reseller.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
        <path
          d="M7.18131 10.4447C6.82355 10.0778 6.23492 10.0691 5.86773 10.4277L4.70744 11.5578C4.68293 11.5947 4.62069 11.651 4.5493 11.7122C4.76886 8.17959 7.39009 5.28062 10.9367 4.74021C13.6759 4.32238 16.4186 5.43687 18.0946 7.64861C18.2783 7.89026 18.5787 8.0123 18.8793 7.96623C19.014 7.94576 19.1433 7.89107 19.253 7.8081C19.4946 7.62437 19.6166 7.32426 19.5714 7.02389C19.5506 6.88838 19.4957 6.75934 19.4127 6.64969C17.3707 3.95438 14.0275 2.59636 10.6878 3.10551C6.32813 3.77039 3.10723 7.35605 2.88605 11.7117C2.86235 11.6861 2.84214 11.6621 2.83217 11.6432L1.5943 10.373C1.23627 10.0066 0.647637 9.99829 0.28072 10.3558C-0.0870064 10.7141 -0.0942802 11.3024 0.263748 11.6704L3.02102 14.4996C3.20852 14.6923 3.4596 14.786 3.70879 14.7798C3.93481 14.7741 4.15922 14.6869 4.33433 14.5161L7.16407 11.7588C7.53179 11.401 7.53933 10.8124 7.18131 10.4447ZM3.74085 12.9563C3.75189 12.956 3.76267 12.9552 3.77344 12.9541C3.76321 12.9668 3.7527 12.9668 3.74085 12.9563Z"
          fill="currentColor"
        />
        <path
          d="M23.7359 12.9195L20.9792 10.09C20.7917 9.89793 20.5403 9.80391 20.2911 9.80983C20.0651 9.81522 19.8402 9.90331 19.6656 10.0736L16.8353 12.8308C16.4678 13.1894 16.46 13.778 16.8183 14.1455C17.1764 14.5119 17.7647 14.5213 18.1316 14.1625L19.2927 13.0321C19.3154 12.9979 19.3709 12.9467 19.4358 12.8909C19.1912 16.3974 16.5786 19.2675 13.0514 19.8055C10.3119 20.2228 7.56915 19.1086 5.89377 16.8971C5.71005 16.6552 5.40967 16.5334 5.10929 16.5792C4.97459 16.5994 4.84501 16.6541 4.73537 16.7374C4.49345 16.9208 4.37142 17.2215 4.41721 17.5218C4.43796 17.6568 4.49291 17.7861 4.57562 17.8958C6.61791 20.5911 9.96085 21.9491 13.3008 21.4397C17.6497 20.7764 20.8652 17.2058 21.0996 12.8642C21.1303 12.8952 21.1559 12.9249 21.1677 12.9472L22.4056 14.2174C22.7639 14.5838 23.3523 14.5922 23.7187 14.2347C24.0869 13.8761 24.0942 13.2877 23.7359 12.9195Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Reseller.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
